import http from '../lib/http';
import guestHttp from '../lib/guestHttp';
import { isGuest } from '../utils/authHelpers';

/* Fire this after any guest cart mutation so the header badge re-fetches */
const emitCartChanged = () => window.dispatchEvent(new Event('cart:changed'));

// ── Cart ──────────────────────────────────────────────────────────────────────

export const getCart = () =>
  isGuest()
    ? guestHttp.get('/api/guest/cart')
    : http.get('/api/customer/carts');

export const addToCart = async ({ productId, quantity = 1, color, size }) => {
  if (isGuest()) {
    const body = { product_id: productId, quantity };
    if (color) body.color = color;
    if (size)  body.size  = size;
    const res = await guestHttp.post('/api/guest/cart', body);
    emitCartChanged(); // ← badge updates immediately after add
    return res;
  }

  const form = new FormData();
  form.append('product_id', String(productId));
  form.append('quantity',   String(quantity));
  if (color) form.append('color', color);
  if (size)  form.append('size',  size);
  return http.post('/api/customer/carts', form);
};

export const updateCartItem = async ({ lineId, quantity, color, size }) => {
  const body = {};
  if (quantity != null) body.quantity = quantity;
  if (color)            body.color    = color;
  if (size)             body.size     = size;

  if (isGuest()) {
    const res = await guestHttp.put(`/api/guest/cart/${lineId}`, body);
    emitCartChanged();
    return res;
  }
  return http.put(`/api/customer/carts/${lineId}`, body);
};

export const removeCartItem = async ({ lineId }) => {
  if (isGuest()) {
    const res = await guestHttp.delete(`/api/guest/cart/${lineId}`);
    emitCartChanged();
    return res;
  }
  return http.delete(`/api/customer/carts/${lineId}`);
};

// Guest has no bulk-delete endpoint — fan out individual deletes
export const removeSelected = async ({ lineIds }) => {
  if (isGuest()) {
    const res = await Promise.all(
      lineIds.map((id) => guestHttp.delete(`/api/guest/cart/${id}`))
    );
    emitCartChanged();
    return res;
  }
  return http.delete('/api/customer/carts/delete-multiple', {
    data: { cart_ids: lineIds },
  });
};

export const clearCart = async () => {
  if (isGuest()) {
    const res = await guestHttp.delete('/api/guest/cart/clear');
    emitCartChanged();
    return res;
  }
  return http.delete('/api/customer/carts/delete-all');
};